import { useMemo } from 'react';
import { useNodeHeight } from './useNodeHeight';
import { useScrollDirection } from '../../hooks/useScrollDirection';
export function useScrollAppear(childRef, options = {}) {
    const { offset = 0, threshold = 10, initialHeight = 0, disabled = false, } = options;
    const scrollDir = useScrollDirection(threshold, disabled);
    const height = useNodeHeight(childRef, initialHeight, disabled);
    const result = useMemo(() => ({
        offset: scrollDir === 'down' ? -height : offset,
        offsetRange: [-height, offset],
    }), [scrollDir, height, offset]);
    return result;
}
//# sourceMappingURL=useScrollAppear.js.map